import { useQuery } from "react-query";
import type { UseQueryResult } from "react-query";
import type { UserDto } from "common/models/api/models/UserDto";
import { default as config } from "common/config/config";
import useUserState from "ui/adapter/state/useUserState";
import { RoleType } from "common/models/role/Role";
import { Queries } from "ui/query/queries";
import type { UseCustomQueryOptions } from "ui/query/react-query-overrides";
import { usersApi } from "../api/usersApi";

export default function useGetUserInfo<TData = UserDto>(
    options: UseCustomQueryOptions<UserDto, unknown, TData, (string | undefined)[]> = {},
): UseQueryResult<TData> {
    const { selectedRole } = useUserState();
    let resourceAddress: string | undefined;

    if (selectedRole?.roleType === RoleType.PARTNER) {
        resourceAddress = selectedRole?.partner?.organizationAddress;
    } else if (selectedRole?.roleType === RoleType.PROGRAM_MANAGER) {
        resourceAddress = selectedRole?.program?.organizationAddress;
    } else {
        resourceAddress = selectedRole?.resourceAddress;
    }

    return useQuery(
        [Queries.USER_INFO, resourceAddress],
        async () => {
            const res = await usersApi.info(resourceAddress, selectedRole?.roleType);
            return res.data;
        },
        { refetchInterval: config.refetchIntervals.userInfo, ...options },
    );
}
